import React from "react";
import "./SectionHeading.scss";

export function SectionHeading({
  eyebrow,
  children,
  action,
}: {
  eyebrow: string;
  children: React.ReactNode;
  action?: React.ReactNode;
}) {
  return (
    <div className="section-heading">
      <div>
        <p className="eyebrow">{eyebrow}</p>
        <h2>{children}</h2>
      </div>
      {action && <div className="section-heading__action">{action}</div>}
    </div>
  );
}
